export default __webpack_public_path__ + "static/media/loader-new.1101420c.gif";